/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, MediaItemDto } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    MediaItemDtoFromJSON,
    MediaItemDtoToJSON,
} from "../models/index";

export interface DeviceGroupMediaItemsGetRequest {
    deviceGroupTag: string;
}

export interface DeviceMediaItemsGetRequest {
    deviceIdentity: string;
}

export interface MediaItemAddToRequest {
    mediaItemId: number;
    add?: boolean;
    deviceGroupTag?: string;
    deviceIdentity?: string;
}

export interface MediaItemDeleteRequest {
    mediaItemId: number;
}

export interface MediaItemInsertRequest {
    body?: MediaItemDto;
}

/**
 *
 */
export class MediaHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get MediaItems by device group tag.
     */
    async deviceGroupMediaItemsGetRaw(
        requestParameters: DeviceGroupMediaItemsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<MediaItemDto>>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupMediaItemsGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/media`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(MediaItemDtoFromJSON),
        );
    }

    /**
     * Get MediaItems by device group tag.
     */
    async deviceGroupMediaItemsGet(
        requestParameters: DeviceGroupMediaItemsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<MediaItemDto>> {
        const response = await this.deviceGroupMediaItemsGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get MediaItems for a specific device.
     */
    async deviceMediaItemsGetRaw(
        requestParameters: DeviceMediaItemsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<MediaItemDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceMediaItemsGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/media`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(MediaItemDtoFromJSON),
        );
    }

    /**
     * Get MediaItems for a specific device.
     */
    async deviceMediaItemsGet(
        requestParameters: DeviceMediaItemsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<MediaItemDto>> {
        const response = await this.deviceMediaItemsGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Add a mediaItem to a device group or device. Ensure file upload has completed first.
     */
    async mediaItemAddToRaw(
        requestParameters: MediaItemAddToRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["mediaItemId"] == null) {
            throw new runtime.RequiredError(
                "mediaItemId",
                'Required parameter "mediaItemId" was null or undefined when calling mediaItemAddTo().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["add"] != null) {
            queryParameters["add"] = requestParameters["add"];
        }

        if (requestParameters["deviceGroupTag"] != null) {
            queryParameters["deviceGroupTag"] =
                requestParameters["deviceGroupTag"];
        }

        if (requestParameters["deviceIdentity"] != null) {
            queryParameters["deviceIdentity"] =
                requestParameters["deviceIdentity"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/media/{mediaItemId}/map`.replace(
                    `{${"mediaItemId"}}`,
                    encodeURIComponent(
                        String(requestParameters["mediaItemId"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Add a mediaItem to a device group or device. Ensure file upload has completed first.
     */
    async mediaItemAddTo(
        requestParameters: MediaItemAddToRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.mediaItemAddToRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete media item, and file from external storage
     */
    async mediaItemDeleteRaw(
        requestParameters: MediaItemDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["mediaItemId"] == null) {
            throw new runtime.RequiredError(
                "mediaItemId",
                'Required parameter "mediaItemId" was null or undefined when calling mediaItemDelete().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/media/{mediaItemId}`.replace(
                    `{${"mediaItemId"}}`,
                    encodeURIComponent(
                        String(requestParameters["mediaItemId"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete media item, and file from external storage
     */
    async mediaItemDelete(
        requestParameters: MediaItemDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.mediaItemDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert a MediaItem. Returns a SAS url to use to upload the file directly to blob storage.
     */
    async mediaItemInsertRaw(
        requestParameters: MediaItemInsertRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/media`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: MediaItemDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert a MediaItem. Returns a SAS url to use to upload the file directly to blob storage.
     */
    async mediaItemInsert(
        requestParameters: MediaItemInsertRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.mediaItemInsertRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
